/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Pricelowest2Inputs */

const id_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terendah:`)
};

const ms_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terendah:`)
};

const da_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laveste:`)
};

const de_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrigster:`)
};

const en_us2_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest:`)
};

const es_es2_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más bajo:`)
};

const es_mx2_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más bajo:`)
};

const fil_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamababa:`)
};

const fr_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus bas :`)
};

const it_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimo:`)
};

const hu_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legalacsonyabb:`)
};

const nl_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laagste:`)
};

const no_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laveste:`)
};

const pl_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najniższa:`)
};

const pt_br2_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais baixo:`)
};

const pt_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais baixo:`)
};

const ro_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel mai mic:`)
};

const fi_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alin:`)
};

const sv_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägsta:`)
};

const vi_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thấp nhất:`)
};

const tr_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Düşük:`)
};

const cs_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnižší:`)
};

const bg_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-ниска:`)
};

const ru_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самая низкая:`)
};

const uk_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найнижча:`)
};

const ar_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأدنى:`)
};

const hi_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम:`)
};

const th_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต่ำสุด:`)
};

const ja_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最安値：`)
};

const zh_cn2_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`历史最低:`)
};

const zh_hant1_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歷史最低：`)
};

const ko_offerdetail_overview_pricelowest2 = /** @type {(inputs: Offerdetail_Overview_Pricelowest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최저:`)
};

/**
* | output |
* | --- |
* | "Lowest:" |
*
* @param {Offerdetail_Overview_Pricelowest2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_pricelowest2 = /** @type {((inputs?: Offerdetail_Overview_Pricelowest2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Pricelowest2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_pricelowest2(inputs)
	if (locale === "ms") return ms_offerdetail_overview_pricelowest2(inputs)
	if (locale === "da") return da_offerdetail_overview_pricelowest2(inputs)
	if (locale === "de") return de_offerdetail_overview_pricelowest2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_pricelowest2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_pricelowest2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_pricelowest2(inputs)
	if (locale === "fil") return fil_offerdetail_overview_pricelowest2(inputs)
	if (locale === "fr") return fr_offerdetail_overview_pricelowest2(inputs)
	if (locale === "it") return it_offerdetail_overview_pricelowest2(inputs)
	if (locale === "hu") return hu_offerdetail_overview_pricelowest2(inputs)
	if (locale === "nl") return nl_offerdetail_overview_pricelowest2(inputs)
	if (locale === "no") return no_offerdetail_overview_pricelowest2(inputs)
	if (locale === "pl") return pl_offerdetail_overview_pricelowest2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_pricelowest2(inputs)
	if (locale === "pt") return pt_offerdetail_overview_pricelowest2(inputs)
	if (locale === "ro") return ro_offerdetail_overview_pricelowest2(inputs)
	if (locale === "fi") return fi_offerdetail_overview_pricelowest2(inputs)
	if (locale === "sv") return sv_offerdetail_overview_pricelowest2(inputs)
	if (locale === "vi") return vi_offerdetail_overview_pricelowest2(inputs)
	if (locale === "tr") return tr_offerdetail_overview_pricelowest2(inputs)
	if (locale === "cs") return cs_offerdetail_overview_pricelowest2(inputs)
	if (locale === "bg") return bg_offerdetail_overview_pricelowest2(inputs)
	if (locale === "ru") return ru_offerdetail_overview_pricelowest2(inputs)
	if (locale === "uk") return uk_offerdetail_overview_pricelowest2(inputs)
	if (locale === "ar") return ar_offerdetail_overview_pricelowest2(inputs)
	if (locale === "hi") return hi_offerdetail_overview_pricelowest2(inputs)
	if (locale === "th") return th_offerdetail_overview_pricelowest2(inputs)
	if (locale === "ja") return ja_offerdetail_overview_pricelowest2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_pricelowest2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_pricelowest2(inputs)
	return ko_offerdetail_overview_pricelowest2(inputs)
});
export { offerdetail_overview_pricelowest2 as "offerDetail.overview.priceLowest" }